import { FamilyRestroomRounded } from '@mui/icons-material';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import Snackbar from '../../common/snackBar';

export interface User {
  userId: number | string;
  userName: string;
}

export interface LoginPayload {
  username: string;
  password: string;
}

export interface AuthState {
  loading: boolean;
  isUserLoggedIn: boolean;
  user: object;
  isLoginError: boolean;
  loginErrorMsg: string;
  error: String | undefined;
  tokenChecking: boolean;
}

const initialState: AuthState = {
  loading: false,
  isUserLoggedIn: false,
  isLoginError: false,
  loginErrorMsg: '',
  user: {},
  error: '',
  tokenChecking: true,
};

const authReducer = createSlice({
  name: 'authentication',
  initialState: initialState,
  reducers: {
    checkUserLogin: (state) => {
      state.tokenChecking = true;
    },
    checkUserLoginSuccess: (state, action) => {
      state.tokenChecking = false;
      state.isUserLoggedIn = true;
      state.user = action.payload;
    },
    checkUserLoginFailed: (state) => {
      state.tokenChecking = false;
      state.isUserLoggedIn = false;
    },
    checkUserLoginCompleted: (state) => {
      state.tokenChecking = false;
    },
    userLoginRequest: (state, action: PayloadAction<LoginPayload>) => {
      state.loading = true;
      state.isLoginError = false;
      state.loginErrorMsg = '';
    },
    userLoginSuccess: (state, action) => {
      state.loading = false;
      state.isUserLoggedIn = true;
      state.user = action.payload.res;
    },
    userLoginFailed: (state, action) => {
      state.loading = false;
      state.isLoginError = true;
      state.loginErrorMsg = 'Something went wrong!';
      Snackbar.error('Login failed, Please check your Username or Password!');
    },
    userLogoutRequest: (state) => {
      state.loading = true;
      state.error = '';
    },
    userLogoutSuccess: (state) => {
      state.loading = false;
      state.isUserLoggedIn = false;
      state.user = {};
    },
    userLogoutFailed: (state) => {
      state.loading = false;
      state.error = 'Error';
    },
  },
});

export const authActions = authReducer.actions;
export default authReducer;
